// Meme coin roster — stats, specials, taunts, and emoji-free coin iconography
// Icons are rendered via SVG using initials + the character color palette.

export const FIGHTERS = [
  {
    id: "doge",
    name: "Dogecoin",
    ticker: "$DOGE",
    title: "The OG Bark-In-Chief",
    initial: "Ð",
    color: "#FFD700",
    accent: "#C58900",
    stats: { hp: 120, atk: 25, def: 18, speed: 15 },
    specialName: "MUCH WOW ROCKET",
    quote: "Such slap. Very hurt. Wow.",
    taunts: [
      "Much wow. Very bonk incoming.",
      "To the moon! You, to the floor!",
      "Doge says: nice try, hooman.",
    ],
    wins: [
      "Such victory. Many pump.",
      "The chart only goes up from here.",
    ],
  },
  {
    id: "shiba",
    name: "Shiba Inu",
    ticker: "$SHIB",
    title: "The Doge Killer",
    initial: "柴",
    color: "#FF6B00",
    accent: "#A33F00",
    stats: { hp: 110, atk: 28, def: 15, speed: 22 },
    specialName: "SHIBARIUM KATANA",
    quote: "Burn the supply, burn the opp.",
    taunts: [
      "I'll zero you faster than my supply.",
      "Shibarium bridge? More like your face.",
    ],
    wins: ["Shib army, assemble!", "Burn complete. Opp vaporized."],
  },
  {
    id: "pepe",
    name: "Pepe",
    ticker: "$PEPE",
    title: "Lord of the Dank Memes",
    initial: "P",
    color: "#39FF14",
    accent: "#1E7A0A",
    stats: { hp: 100, atk: 32, def: 12, speed: 25 },
    specialName: "FEELS GOOD SLAP",
    quote: "Feels good, man.",
    taunts: [
      "You cannot rare-meme me.",
      "This is a rare one. 300 damage incoming.",
    ],
    wins: ["Feels REALLY good, man.", "Kek. Absolutely demolished."],
  },
  {
    id: "wif",
    name: "Dogwifhat",
    ticker: "$WIF",
    title: "Keeper of the Hat",
    initial: "W",
    color: "#00E5FF",
    accent: "#00647A",
    stats: { hp: 105, atk: 27, def: 20, speed: 18 },
    specialName: "BEANIE BOOMERANG",
    quote: "The hat stays ON.",
    taunts: [
      "My hat is cooler than your floor price.",
      "This beanie has Solana speed.",
    ],
    wins: ["Hat intact. Opp destroyed.", "Wif stays, you stay down."],
  },
  {
    id: "bonk",
    name: "Bonk",
    ticker: "$BONK",
    title: "Solana's Bat Wielder",
    initial: "B",
    color: "#FF2A85",
    accent: "#8E0A4A",
    stats: { hp: 115, atk: 30, def: 14, speed: 20 },
    specialName: "HORNY JAIL SLAM",
    quote: "BONK! Straight to zero.",
    taunts: [
      "Go directly to horny jail.",
      "BONK! Do not pass GO.",
    ],
    wins: ["BONK complete.", "Thanks for playing. Now jail."],
  },
  {
    id: "floki",
    name: "Floki",
    ticker: "$FLOKI",
    title: "The Viking Pup",
    initial: "F",
    color: "#FFDF00",
    accent: "#8E7A00",
    stats: { hp: 130, atk: 24, def: 22, speed: 12 },
    specialName: "VALHALLA AXE TOSS",
    quote: "By Thor's hammer!",
    taunts: [
      "Odin sent me. You will not survive.",
      "Valhalla is calling. For you.",
    ],
    wins: ["To Valhalla!", "The chart gods are pleased."],
  },
  {
    id: "babydoge",
    name: "Baby Doge",
    ticker: "$BABYDOGE",
    title: "The Cute Crusader",
    initial: "b",
    color: "#FF9FBF",
    accent: "#B33A72",
    stats: { hp: 95, atk: 29, def: 16, speed: 28 },
    specialName: "HYPER DEFLATE",
    quote: "Doo doo doo, doo doo!",
    taunts: [
      "Tiny baby, HUGE damage.",
      "Doo doo doo, GG EZ.",
    ],
    wins: ["Baby Doge supremacy.", "Deflation complete. You = burned."],
  },
  {
    id: "brett",
    name: "Brett",
    ticker: "$BRETT",
    title: "Base Chain Mascot",
    initial: "Br",
    color: "#2A85FF",
    accent: "#0A3A8E",
    stats: { hp: 125, atk: 26, def: 19, speed: 16 },
    specialName: "BASED UPPERCUT",
    quote: "Based and blue-pilled.",
    taunts: [
      "Stay based. You stay seething.",
      "Base chain, main brain.",
    ],
    wins: ["Based victory achieved.", "Brett wins. Chart to the moon."],
  },
];

export const COMMENTARY = [
  "The crowd goes WILD!",
  "Did you see that?! Absolute carnage!",
  "The chart is PUMPING and so are the fists!",
  "This is better than the 2021 bull run!",
  "Someone call a medic — and a market maker!",
  "That hit harder than a 90% rug pull!",
  "The whales are watching. Diamond hands on the ropes!",
  "This is pure degenerate energy right here!",
  "Analysts predict: pure chaos.",
  "This fight is bullish on bruises!",
  "Even Vitalik would be impressed.",
  "The halving comes for us all!",
];

export const TICKER_TAPE = [
  "$DOGE +42.0% TO THE MOON",
  "$PEPE +69.0% KEK",
  "$SHIB +13.1% WOOF",
  "$WIF +18.7% HAT ON",
  "$BONK +22.4% BONK",
  "$FLOKI +9.0% VALHALLA",
  "$BABYDOGE +7.7% DOO DOO",
  "$BRETT +11.1% BASED",
];
